import { useContext } from 'react'
import { StateContext } from './context'
import type { AppContextInterface } from './context'

const useEMTState = (): AppContextInterface => {
  const state = useContext(StateContext)
  return state
}

export default useEMTState
